import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const DropdownArrowIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M8.00003 4.43481C8.00003 4.68027 7.90946 4.9259 7.72728 5.11782C7.35005 5.51452 6.7225 5.53034 6.32563 5.15328L3.99308 2.93546L1.67669 5.15102C1.28121 5.52947 0.653659 5.51556 0.275041 5.1199C-0.103577 4.72408 -0.0894963 4.0967 0.306158 3.71825L3.30538 0.849066C3.68782 0.483312 4.29016 0.482617 4.67382 0.846806L7.69182 3.71582C7.89642 3.91104 8.00003 4.17232 8.00003 4.43481Z"
    />
  </svg>
);

DropdownArrowIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

DropdownArrowIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(8, 6),
};

export default DropdownArrowIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/dropdown-arrow.js